import React, { createContext, useContext } from "react";

// Detect environment: local (dev) vs production
const isLocal = !process.env.NODE_ENV || process.env.NODE_ENV === "development";

// Base URLs
const API_BASE_URL = isLocal 
  ? "http://localhost:8000" 
  : "https://backend.jobflowonline.com";
// const API_BASE_URL = 'https://tv43rg77-8000.uks1.devtunnels.ms/'

// Create context
const ApiContext = createContext(API_BASE_URL);

// Provider component
export const ApiProvider = ({ children }) => {
  return (
    <ApiContext.Provider value={API_BASE_URL}>
      {children}
    </ApiContext.Provider>
  );
};

// Custom hook for consuming context
export const useApi = () => {
  return useContext(ApiContext);
};
